import { Card, Form } from 'react-bootstrap';
import { HoganUserData } from './DataDefinitions';
import { useTranslation } from 'react-i18next';
import SettingsChangePassword from './SettingsChangePassword';

interface UserInfoProps {
  hoganUser: HoganUserData;
  isAdd: boolean,
  errors: { login?: string, password?: string },
  onUserChange: (name: string, value: any) => void;
}

const HoganLoginInfo = ({ hoganUser, isAdd, errors, onUserChange }: UserInfoProps) => {

  const { t } = useTranslation();

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onUserChange(name, value);
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    onUserChange(name, checked);
  };

  return (
    <Card className='border border-light' >
      <Card.Body>
        <h4 className="mb-2">{t("UserInfo.user_information")}</h4>

        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="login">{t("UserInfo.login")}</Form.Label>
          <Form.Control
            id="hogan-user-id"
            name="login"
            type="text"
            required
            placeholder="AB1234567"
            className="form-icon-input"
            onChange={handleInputChange}
            isInvalid={!!errors.login}
            value={hoganUser.login}
          />
          <Form.Control.Feedback type="invalid">
            Field cannot be empty
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="login">{t("UserInfo.password")}</Form.Label>
          <Form.Control
            id="hogan-user-pwd"
            name="password"
            type="password"
            required
            className="form-icon-input"
            onChange={handleInputChange}
            isInvalid={!!errors.password}
            value={hoganUser.password}
          />
          <Form.Control.Feedback type="invalid">
            Field cannot be empty
          </Form.Control.Feedback>
        </Form.Group>

        <div className='mt-3'>
          <Form.Check
            type="checkbox"
            id="available"
            name="hogan_available"
            label="Enable hogan"
            defaultChecked={hoganUser?.hogan_available}
            onChange={handleCheckChange}
          /></div>

      </Card.Body>
    </Card>
  );
};

export default HoganLoginInfo;
